import {
  CommentCreateInterface,
  CompanyListItemInterface,
  IPaginatorData,
  SubstituteUserInterface,
  SubstitutionAdminCreateInterface,
  SubstitutionCreateInterface,
  SubstitutionDetailsInterface,
  SubstitutionInterface,
  SubstitutionsListInterface,
  SubstitutionsListQueryInterface,
  SubstitutionStatisticsInterface,
  SubstitutionUsersListQueryInterface,
  UserProfileModelInterface,
} from '@elearning-platform/api-types/interfaces';
import { stringify } from 'query-string';

import { api } from '../api';

export const createSubstitution: (data: SubstitutionCreateInterface) => Promise<SubstitutionInterface>
  = (data: SubstitutionCreateInterface): Promise<SubstitutionInterface> => api.post('substitutions', data);

export const createSubstitutionBySupervisor: (data: SubstitutionAdminCreateInterface) => Promise<SubstitutionInterface>
  = (data: SubstitutionAdminCreateInterface): Promise<SubstitutionInterface> => api.post(
    'substitutions/by-supervisor', data
  );

export const getSubstitutionsList: (params: SubstitutionsListQueryInterface) => Promise<IPaginatorData<SubstitutionsListInterface>>
  = (params: SubstitutionsListQueryInterface): Promise<IPaginatorData<SubstitutionsListInterface>> => api.get(
    `substitutions/list?${stringify(params, { skipEmptyString: true })}`
  );

export const getSubstitutionsStatistics: () => Promise<SubstitutionStatisticsInterface>
  = (): Promise<SubstitutionStatisticsInterface> => api.get('substitutions/statistics');

export const getUsersAvailableAsSubstitutes: (params: SubstitutionUsersListQueryInterface) => Promise<SubstituteUserInterface[]>
  = (params: SubstitutionUsersListQueryInterface): Promise<SubstituteUserInterface[]> => api.get(
    `substitutions/users/available?${stringify(params, { skipEmptyString: true })}`
  );

export const getUsersNeedsSubstitute: (search: string) => Promise<UserProfileModelInterface[]>
  = (search: string): Promise<UserProfileModelInterface[]> => api.get(
    `substitutions/users/unassigned?${stringify({ search }, { skipEmptyString: true })}`
  );

export const getUserCompaniesIds: (timestampFrom: number, timestampTo?: number, id?: number) => Promise<CompanyListItemInterface[]>
  = (timestampFrom: number, timestampTo?: number, id?: number): Promise<CompanyListItemInterface[]> => api.get(
    `substitutions/companies/user?${stringify({ id, timestampFrom, timestampTo }, { skipEmptyString: true })}`
  );

export const getCompaniesList: () => Promise<CompanyListItemInterface[]>
  = (): Promise<CompanyListItemInterface[]> => api.get('substitutions/companies');

export const getSubstitutionDetails: (id: number) => Promise<SubstitutionDetailsInterface>
  = (id: number): Promise<SubstitutionDetailsInterface> => api.get(`substitutions/${id}`);

export const acceptSubstitution: (id: number) => Promise<void> = (id: number): Promise<void> => api.post(
  `substitutions/${id}/accept`
);

export const verifySubstitution: (id: number) => Promise<void> = (id: number): Promise<void> => api.post(
  `substitutions/${id}/verify`
);

export const rejectSubstitution: (id: number, data: CommentCreateInterface) => Promise<void> = (
  id: number, data: CommentCreateInterface
): Promise<void> => api.post(`substitutions/${id}/reject`, data);

export const cancelSubstitution: (id: number) => Promise<void> = (id: number): Promise<void> => api.post(`substitutions/${id}/cancel`);
